import { useEffect, useMemo, useState } from 'react';

import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { useApi } from 'contexts/ApiContext';
import { TEMPLATES_PATH } from 'routes/routes.constants';

import useMatchPath from '@polyai/common/hooks/useMatchPath';

import type api from 'api';

const useProjection = (
  accountId: string,
  projectId: string,
  branchId: string,
  options?: UseQueryOptions<
    Awaited<ReturnType<typeof api.getProjection>>,
    unknown,
    Awaited<ReturnType<typeof api.getProjection>>
  >,
) => {
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const api = useApi();

  const matchPath = useMatchPath();
  const isSampleProject = useMemo(
    () => !!matchPath(TEMPLATES_PATH, false),
    [matchPath],
  );

  const result = useQuery({
    queryKey: isSampleProject
      ? [projectId, 'sample-project-projection']
      : [accountId, projectId, branchId, 'projection'],
    queryFn: () =>
      isSampleProject
        ? api.methods.getSampleProjectProjection(projectId)
        : api.methods.getProjection({ accountId, projectId, branchId }),
    cacheTime: 0,
    staleTime: 0,
    ...options,
  });

  useEffect(() => {
    if (!result.isLoading) {
      setIsFirstLoad(false);
    }
  }, [result.isLoading]);

  return { ...result, isFirstLoad, isSampleProject };
};

export default useProjection;
